import { render, staticRenderFns } from "./DetalhesDoPlano.vue?vue&type=template&id=01955bbd&scoped=true&"
import script from "./DetalhesDoPlano.vue?vue&type=script&lang=js&"
export * from "./DetalhesDoPlano.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesDoPlano.vue?vue&type=style&index=0&id=01955bbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01955bbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
